import constant from "../../constant";
import router from "../../router";

const api = constant.api + "payments_repairs";

const state = () => ({
  all: [],
  rows: [],
  current: {},
});

const getters = {
  getAll: (state) => state.rows,
  getCurrent: (state) => state.current,
};

const actions = {
  async fetchAll({ commit }) {
    try {
      const data = await this.$api.fetch(api);
      commit("SET_ROWS", Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
      commit("SET_ROWS", []);
    }
  },

  async show({ commit }, reference) {
    try {
      const res = await this.$api.show(api + "/" + reference);
      const row = res.data || res || {};
      commit("SET_CURRENT", row);
    } catch (e) {
      console.error(e);
    }
  },

  async store({ dispatch }, data) {
    const response = await this.$api.create(api, data, { confirm: false });
    const status = response.data && response.data.status;
    if (status === "success") {
      router.push({ name: "payments-repairs-index" });
    }
  },

  async update({ dispatch }, payload) {
    const ref = payload.reference;
    const body = { ...payload };
    delete body.reference;
    const response = await this.$api.update(api + "/" + ref, body, { confirm: false });
    const status = response.data && response.data.status;
    if (status === "success") {
      router.push({ name: "payments-repairs-index" });
    }
  },

  async destroy({ dispatch, commit }, reference) {
    const response = await this.$api.delete(api + "/" + reference, { confirm: true });
    const status = response.data && response.data.status;
    if (status === "success") {
      if (response.data && Array.isArray(response.data.data)) {
        commit("SET_ROWS", response.data.data);
      } else {
        dispatch("fetchAll");
      }
    }
  },
};

const mutations = {
  SET_ROWS(state, rows) {
    state.all = rows;
    state.rows = rows;
  },
  SET_CURRENT(state, row) {
    state.current = row;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
